import { createTheme } from "@mui/material/styles";
declare module "@mui/material/styles" {
  interface TypographyVariants {
    header: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    header?: React.CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    header: true;
  }
}
const theme = createTheme({
  direction: "rtl",
  palette: {
    primary: {
      main: "#89C6CE",
    },
    secondary: {
      main: "#0b0b0b",
    },
    background: {
      default: "#0b0b0b",
    },
    text: {
      primary: "#082A2E",
      secondary: "#082A2E",
    },
  },
  typography: {
    fontFamily: "vaziriFont",
    allVariants: {
      color: "#082A2E",
    },
    h6: {
      fontWeight: 600,
      fontSize: "24px",
    },
    h5: {
      fontWeight: 600,
      fontSize: "32px",
    },
    header: {
      fontWeight: 600,
      fontSize: "16px",
      color: "#082A2E",
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#082A2E !important",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          color: "#fff",
          fontSize: "14px",
          backgroundColor: "#666666 !important",

          padding: "6px 12px",
          "&::placeholder": {
            color: "#666666",
            opacity: 1,
          },
        },
        root: {
          backgroundColor: "#666666",
          height: 38,
          "& fieldset": {
            borderColor: "#666666",
          },
          "&:hover fieldset": {
            borderColor: "#89C6CE",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#89C6CE",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#ffffff",
          fontSize: "14px",
          "&.Mui-focused": {
            color: "#89C6CE",
          },
        },
      },
    },
  },
});

export default theme;
